<ng-select (change)="onChange($event)"
           [(ngModel)]="periodValue"
           [items]="periods"
           [loading]="loading"
           [disabled] = isDisable
           bindLabel="name"
           [placeholder]="periodValue ? '' : (all ? 'All Period' : 'Select Period')"
           class="selector-style">

    <ng-template ng-option-tmp let-item="item">
        <div class="custom-option-style">
            {{ item.name || 'Unnamed Period' }}
        </div>
    </ng-template>
</ng-select>
